import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Read_More_btn.css";
import React from "react";
import { useNavigate } from "react-router-dom";
import { faArrowRightLong } from "@fortawesome/free-solid-svg-icons";

const Read_More_btn = ({ link, btnText = "Read More", className = "" }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate(link);
  };

  return (
    <button className={`read_more_btn ${className}`} onClick={handleClick}>
      <span className="btn_text">{btnText}</span>
      <span className="icon_wrapper">
        <FontAwesomeIcon icon={faArrowRightLong} className="angle_icon" />
      </span>
    </button>
  );
};

export default Read_More_btn;
